export const libraryDeletedDisciplineDisplayName = 'Deleted discipline'
